/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum VoteStatus {
  Success = "Success",
  AlreadyVoted = "AlreadyVoted",
  Failed = "Failed",
  MailError = "MailError",
  Closed = "Closed",
}

export function VoteStatusFromJSON(json: any): VoteStatus {
  return VoteStatusFromJSONTyped(json, false);
}

export function VoteStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoteStatus {
  return json as VoteStatus;
}

export function VoteStatusToJSON(value?: VoteStatus | null): any {
  return value as any;
}
